import { DateTime } from "luxon";
import { DateShown } from "./DateShown";
import { DateSelected } from "./DateSelected";

/** compute the date range from the value received by primereact's Calendar component */
export const getDateShown = (dateSelected: DateSelected): DateShown => {
    if (
        Array.isArray(dateSelected) &&
        dateSelected.length === 2 &&
        dateSelected[0] instanceof Date
    ) {
        if (dateSelected[1] === null) {
            const from = DateTime.fromJSDate(dateSelected[0]);
            return [from, from];
        } else {
            const from = DateTime.fromJSDate(dateSelected[0]);
            const to = DateTime.fromJSDate(dateSelected[1]);
            // ensure that the range is not reversed
            if (from <= to) {
                return [from, to];
            } else {
                return [to, from];
            }
        }
    }
    // if there is no selection from the calendar, default to today
    const today = DateTime.now().startOf("day");
    return [today, today];
};
